"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.weak-map.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es6.symbol.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _PageFooter = _interopRequireDefault(require("../pages/PageFooter"));

var _ContactSection = _interopRequireDefault(require("../pages/ContactSection"));

require("../../sass/components/ErrorPage/ErrorPage.css");

var _logomarkBlue = _interopRequireDefault(require("@evdy/web-core/dist/images/logomark-blue.svg"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var defaultBodyText = 'Something’s gone wrong. Our team has been notified and we’re ' + 'working to fix the issue. Please tell us more about what happened.'; //console.log('reminder that sentry error reporter is not working');

var ErrorPage = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorPage, _React$Component);

  var _super = _createSuper(ErrorPage);

  function ErrorPage(props) {
    var _this;

    _classCallCheck(this, ErrorPage);

    _this = _super.call(this, props);
    _this.errorPop = _this.errorPop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ErrorPage, [{
    key: "errorPop",
    value: function errorPop() {
      var _this$props = this.props,
          errorPop = _this$props.errorPop,
          location = _this$props.location;

      var _ref = location || {},
          query = _ref.query;

      var _ref2 = query || {},
          eid = _ref2.eid;

      if (errorPop) {
        this.props.errorPop();
      } else {
        var eventId = eid || Sentry.lastEventId();
        eventId && Sentry.showReportDialog({
          eventId: eventId
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          bodyText = _this$props2.bodyText,
          buttonText = _this$props2.buttonText,
          hasButton = _this$props2.hasButton,
          children = _this$props2.children;
      return [/*#__PURE__*/_react.default.createElement("div", {
        className: "error-notice",
        key: "error-notice"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "error-logo",
        src: _logomarkBlue.default,
        alt: "Everdays Logo"
      }), /*#__PURE__*/_react.default.createElement("h1", {
        className: "error-title"
      }, title), children ? children : /*#__PURE__*/_react.default.createElement("p", null, bodyText), hasButton && /*#__PURE__*/_react.default.createElement("button", {
        className: "button-primary",
        onClick: this.errorPop
      }, buttonText)), /*#__PURE__*/_react.default.createElement(_ContactSection.default, {
        key: "contact::500::support",
        currentPage: "500",
        contact: "support@everdays.com"
      }), /*#__PURE__*/_react.default.createElement(_PageFooter.default, {
        key: "footer::500",
        currentPage: "500"
      })];
    }
  }]);

  return ErrorPage;
}(_react.default.Component);

exports.default = ErrorPage;
ErrorPage.propTypes = {
  title: _propTypes.default.string,
  bodyText: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  hasButton: _propTypes.default.bool,
  errorPop: _propTypes.default.func
};
ErrorPage.defaultProps = {
  title: 'We’re sorry',
  bodyText: defaultBodyText,
  buttonText: 'Fill Out a Report',
  hasButton: true,
  errorPop: null
};